// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"SearchForm_searchForm__3tlus","center":"SearchForm_center__21GM_","label":"SearchForm_label__3kqP7","searchBar":"SearchForm_searchBar__3_1-6"};